import { AxiosResponse } from 'axios';
import { IGroupBookingQuote } from '../Models/IGroupBookingQuote';
import BaseApi from './BaseApi';

/**
 * The BookingsApi class.
 *
 */
class QuotesApi extends BaseApi {
	constructor() {
        super('quotes');
	}
	
	/** 
	 * Get group booking
	 *  
	 * @return {Promise} The request promise.
	*/
	public getGroupBooking = (bookingId: string, quoteId: string): Promise<AxiosResponse<IGroupBookingQuote>> => {		
		return this._get(`${bookingId}`, { 
			quoteId
		});
	}

	/** 
	 * Update group booking
	 *  
	 * @return {Promise} The request promise.
	*/
	public uploadGroupBookingSignedQuote = (bookingId: string, quoteId: string, file: File): Promise<AxiosResponse<IGroupBookingQuote>> => {		
		var formData = new FormData();
		formData.append('QuoteId', quoteId);
		formData.append("File", file);
		return this._postForm(`${bookingId}`, formData);
	}

	/** 
	 * Cancel group booking quote
	 *  
	 * @return {Promise} The request promise.
	*/
	public cancelGroupBookingQuote = (bookingId: string, quoteId: string): Promise<AxiosResponse> => {		
		return this._get(`${bookingId}/cancel`, { 
			quoteId
		});
	}
}

export default QuotesApi;